import { PETS, PET_IDS, addPetXp, defaultPets, type PetsState } from '@knight/shared';

/** Offline companions live in the browser; online they come from the account. */
export function loadLocalPets(): PetsState {
  try {
    const raw = localStorage.getItem('knight.pets');
    if (raw) {
      const p = JSON.parse(raw) as PetsState;
      if (p && p.owned) return p;
    }
  } catch {
    /* ignore */
  }
  // offline mode is a fallback: every companion is available at level 1
  const s = defaultPets();
  for (const id of PET_IDS) if (!s.owned[id]) s.owned[id] = { level: 1, xp: 0 };
  saveLocalPets(s);
  return s;
}

export function saveLocalPets(s: PetsState): void {
  try {
    localStorage.setItem('knight.pets', JSON.stringify(s));
  } catch {
    /* ignore */
  }
}

export function localActivePet(): { id: string; level: number } | null {
  const s = loadLocalPets();
  if (!s.active || !s.owned[s.active] || !PETS[s.active]) return null;
  return { id: s.active, level: s.owned[s.active].level };
}

export function localPetXp(xp: number): void {
  const s = loadLocalPets();
  if (!s.active || !s.owned[s.active]) return;
  addPetXp(s.owned[s.active], xp);
  saveLocalPets(s);
}
